import { request } from "../../utils/AxiosInstance";
export const GetParticipateEvaluator = async () => {
  return request({ url: "get_participant_evaluators" });
};
